export const environment = {
    production: false,
    version: 'development',
    firebase: {
        apiKey: 'AIzaSyDU3SqqiWNWaWi_OtS1rRWzgo2BJjSxBFg',
        authDomain: 'tvn-media-tools.firebaseapp.com',
        databaseURL: 'https://tvn-media-tools.firebaseio.com',
        projectId: 'tvn-media-tools',
        storageBucket: 'tvn-media-tools.appspot.com',
        messagingSenderId: '316075347371'
    }
};